import { mergeApis, Zodios } from "@zodios/core";
import * as qs from "qs";

import { backofficeAppointmentApi } from "@/api/backoffice/appointment/backoffice-appointment-api.ts";
import { backofficeAutoDiagApi } from "@/api/backoffice/auto-diag/backoffice-auto-diag-api.ts";
import { backofficeBankingInformationApi } from "@/api/backoffice/banking-information/backoffice-banking-information-api.ts";
import { backofficeBonusOfferApi } from "@/api/backoffice/bonus-offer/backoffice-bonus-offer-api.ts";
import { backofficeCompanyApi } from "@/api/backoffice/company/backoffice-company-api.ts";
import { backofficeEmailApi } from "@/api/backoffice/email/backoffice-email-api.ts";
import { backofficeEscApi } from "@/api/backoffice/esc/backoffice-esc-api.ts";
import { backofficeHeatPumpApi } from "@/api/backoffice/heatpump/backoffice-heatpump-api.ts";
import { backofficeExternalLoginApi } from "@/api/backoffice/login/backoffice-external-login-api.ts";
import { backofficeLoginApi } from "@/api/backoffice/login/backoffice-login-api.ts";
import { backofficeModulatorApi } from "@/api/backoffice/modulator/backoffice-modulator-api.ts";
import { backofficeMomboxApi } from "@/api/backoffice/mombox/backoffice-mombox-api.ts";
import { backofficeMyvApi } from "@/api/backoffice/myv/backoffice-myv-api.ts";
import { backofficeOdityExtendedApi } from "@/api/backoffice/odity-extended/backoffice-odity-extended-api.ts";
import { backofficeOperationsApi } from "@/api/backoffice/operations/backoffice-operations-api.ts";
import { backofficeOperatorApi } from "@/api/backoffice/operator/backoffice-operator-api.ts";
import { backofficePdlApi } from "@/api/backoffice/pdl/backoffice-pdl-api.ts";
import { backofficePersonalizationApi } from "@/api/backoffice/personalization/backoffice-personalization-api.ts";
import { backofficePhoningApi } from "@/api/backoffice/phoning/backoffice-phoning-api.ts";
import { backofficeReferenceApi } from "@/api/backoffice/reference/backoffice-reference-api.ts";
import { backofficeReinterventionApi } from "@/api/backoffice/reintervention/backoffice-reintervention-api.ts";
import { backofficeRootApi } from "@/api/backoffice/root/backoffice-root-api.ts";
import { backofficeSignatureApi } from "@/api/backoffice/signature/backoffice-signature-api.ts";
import { backofficeSiteApi } from "@/api/backoffice/site/backoffice-site-api.ts";
import { backofficeSubscriberApi } from "@/api/backoffice/subscriber/backoffice-subscriber-api.ts";
import { backofficeSupportApi } from "@/api/backoffice/support/backoffice-support-api.ts";
import { backofficeSurveyApi } from "@/api/backoffice/survey/backoffice-survey-api.ts";
import { backofficeVxApi } from "@/api/backoffice/vx/backoffice-vx-api.ts";
import { backofficeZendeskApi } from "@/api/backoffice/zendesk/backoffice-zendesk-api.ts";

type CreateBackofficeApiOpts = {
  VITE_BACKOFFICE_BASE_URL: string;
  VITE_ZODIOS_VALIDATE: boolean;
};

export function makeBackofficeApiDefinition() {
  return mergeApis({
    "/api": backofficeRootApi,
    "/api/appointments": backofficeAppointmentApi,
    "/api/autodiag": backofficeAutoDiagApi,
    "/api/banking-information": backofficeBankingInformationApi,
    "/api/bonus-offer": backofficeBonusOfferApi,
    "/api/company": backofficeCompanyApi,
    "/api/email": backofficeEmailApi,
    "/api/esc": backofficeEscApi,
    "/api/heatpump": backofficeHeatPumpApi,
    "/api/modulator": backofficeModulatorApi,
    "/api/mombox": backofficeMomboxApi,
    "/api/myv": backofficeMyvApi,
    "/api/odity-extended": backofficeOdityExtendedApi,
    "/api/operator": backofficeOperatorApi,
    "/api/operations": backofficeOperationsApi,
    "/api/personalization": backofficePersonalizationApi,
    "/api/phoning": backofficePhoningApi,
    "/api/pdl": backofficePdlApi,
    "/api/reference": backofficeReferenceApi,
    "/api/reintervention": backofficeReinterventionApi,
    "/api/signature": backofficeSignatureApi,
    "/api/site": backofficeSiteApi,
    "/api/subscriber": backofficeSubscriberApi,
    "/api/support": backofficeSupportApi,
    "/api/survey": backofficeSurveyApi,
    "/api/vx": backofficeVxApi,
    "/api/zendesk": backofficeZendeskApi,
    "/login": backofficeLoginApi,
    "/external/login": backofficeExternalLoginApi,
  });
}

export type BackofficeApiDefinition = ReturnType<typeof makeBackofficeApiDefinition>;

export function createBackofficeApi(opts: CreateBackofficeApiOpts) {
  return new Zodios(opts.VITE_BACKOFFICE_BASE_URL, makeBackofficeApiDefinition(), {
    validate: opts.VITE_ZODIOS_VALIDATE,
    axiosConfig: {
      paramsSerializer: {
        serialize: (params) => qs.stringify(params, { arrayFormat: "comma" }),
      },
    },
  });
}

export type ZodiosBackofficeApi = ReturnType<typeof createBackofficeApi>;
